import React from 'react';
import { SimpleClose, SimpleMinus, SimplePlus } from '@profitfy/pakkun-icons';
import { useTheme } from 'styled-components/macro';

import { useCreateOrder } from '@helpers/hooks/pages/dashboard/orders/useCreateOrder';
import { EHeadingSize, EHeadingWeight } from '@domain/enums/components/EHeading';
import VariantInput from './ProductInput';

import * as S from './styles';

const FocusedVariant: React.FC = () => {
  const theme = useTheme();

  const {
    isProductsComponentOpen,
    selectedProduct,
    removeProduct,
    handleCardExpanded,
    quantity,
    increaseQuantity,
    decreaseQuantity,
    focusedProductCardRef,
    onCardBlur,
    index,
  } = useCreateOrder();

  const [isVariantImageError, setIsVariantImageError] = React.useState<boolean>(false);

  const onBlur = React.useCallback(
    event => {
      const isBlurringOutside = !event.currentTarget.contains(event.relatedTarget);

      if (isBlurringOutside && !isProductsComponentOpen) {
        onCardBlur();
        handleCardExpanded();
      }
    },
    [handleCardExpanded, isProductsComponentOpen, onCardBlur],
  );

  React.useEffect(() => {
    focusedProductCardRef?.current?.focus();
  }, [focusedProductCardRef]);

  return (
    <S.Wrapper tabIndex={0} onBlur={onBlur} ref={focusedProductCardRef}>
      <S.Title fontWeight={EHeadingWeight.REGULAR} type={EHeadingSize.H5}>
        Adicionar produto
      </S.Title>

      <S.VariantWrapper>
        {selectedProduct ? (
          <S.Variant>
            <S.VariantImageAndDetails>
              {!isVariantImageError && selectedProduct?.product?.image_url ? (
                <S.VariantImage
                  src={selectedProduct?.product?.image_url}
                  alt="Profitfy.me Product"
                  onError={() => setIsVariantImageError(true)}
                />
              ) : (
                <S.NoImage />
              )}

              <S.VariantDetails>
                <S.VariantName>{selectedProduct?.product?.name}</S.VariantName>
                {/* <S.VariantSku>{`SKU: ${selectedProduct?.product?.sku}`}</S.VariantSku> */}
              </S.VariantDetails>
            </S.VariantImageAndDetails>

            <S.RemoveButton type="button" onClick={removeProduct}>
              <SimpleClose size={16} color={theme.colors.gray[2]} />
            </S.RemoveButton>
          </S.Variant>
        ) : (
          <VariantInput />
        )}

        <S.VariantNumberText>{`#${index + 1}`}</S.VariantNumberText>
      </S.VariantWrapper>

      <S.QuantityWrapper>
        <S.QuantityLabel>Quantidade</S.QuantityLabel>
        <S.QuantityButtonsWrapper>
          <S.RemoveQuantityButton onClick={decreaseQuantity} type="button">
            <SimpleMinus size={14} color={theme.colors.gray[1]} />
          </S.RemoveQuantityButton>
          <S.QuantityText>{quantity}</S.QuantityText>
          <S.AddQuantityButton onClick={increaseQuantity} type="button">
            <SimplePlus size={14} color={theme.colors.gray[1]} />
          </S.AddQuantityButton>
        </S.QuantityButtonsWrapper>
      </S.QuantityWrapper>
    </S.Wrapper>
  );
};

export default FocusedVariant;
